const VIEW_FILTER_PREFIX = "viewFilters-";

export const stripViewFilterPrefix = (gridKey: string): string =>
    gridKey.startsWith(VIEW_FILTER_PREFIX) ? gridKey.slice(VIEW_FILTER_PREFIX.length) : gridKey;
